<template>
  <div class="sleeve">
    <hirer-overview-panel></hirer-overview-panel>
  </div>
</template>

<script>
import HirerOverviewPanel from './panels/Overview'

export default {
  components: {
    HirerOverviewPanel,
  }
}
</script>
